export const REPORT_SUBMIT_REQUEST = 'report_submit_request';
export const REPORT_SUBMIT_SUCCESS = 'report_submit_success';
export const REPORT_SUBMIT_FAILURE = 'report_submit_failure';
export const REPORT_ISSUE_REFRESH = 'report_issue_refresh';
